import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import * as React from 'react';
import { isIE } from '../../utils/isIE';

/**
 * Компонент используемый как обертка для SVG элементов, если известен лишь один из размеров.
 * Сделано специально для IE10+ (включая Edge), т.к. они не умеют нормально масштабировать SVG.
 */
export var SvgScalable = /*#__PURE__*/function (_React$Component) {
  _inherits(SvgScalable, _React$Component);

  var _super = _createSuper(SvgScalable);

  function SvgScalable(props) {
    var _this;

    _classCallCheck(this, SvgScalable);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "element", void 0);

    _defineProperty(_assertThisInitialized(_this), "enabled", void 0);

    _this.enabled = false;
    return _this;
  }

  _createClass(SvgScalable, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.enabled = isIE();
      this.updateSizes();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateSizes();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("svg", _extends({
        ref: function ref(element) {
          return _this2.element = element;
        }
      }, this.props), this.props.children);
    }
  }, {
    key: "updateSizes",
    value: function updateSizes() {
      if (!this.enabled) {
        return;
      }

      if (typeof this.props.width === 'undefined' && typeof this.props.height === 'undefined') {
        throw new Error('Either width or height should be set');
      }

      if (typeof this.props.width !== 'undefined' && typeof this.props.height !== 'undefined') {
        return;
      }

      var boundingClientRect = this.element.getBoundingClientRect();
      var bBox = this.element.getBBox();

      if (typeof this.props.height !== 'undefined') {
        var height = boundingClientRect.height;
        var ratio = bBox.width / bBox.height;
        var width = height * ratio;
        this.element.setAttribute('width', "".concat(Math.round(width)));
      } else {
        var _width = boundingClientRect.width;

        var _ratio = bBox.height / bBox.width;

        var _height = _width * _ratio;

        this.element.setAttribute('height', "".concat(Math.round(_height)));
      }
    }
  }]);

  return SvgScalable;
}(React.Component);